import { render, staticRenderFns } from "./SkeletonPolicyShowScope.vue?vue&type=template&id=31eb666e&scoped=true&"
import script from "./SkeletonPolicyShowScope.vue?vue&type=script&lang=js&"
export * from "./SkeletonPolicyShowScope.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonPolicyShowScope.vue?vue&type=style&index=0&id=31eb666e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eb666e",
  null
  
)

export default component.exports